import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MobileMenu from '../components/MobileMenu';
import PopupSearch from '../components/PopupSearch';
import ScrollToTop from '../components/ScrollToTop';

// import './About.css';

const About: React.FC = () => {
  return (
    <>
      <MobileMenu />
      <PopupSearch />

      <main className="main">
        <Header />
<link rel="stylesheet" href="/assets/css/About.css" />
        {/* HERO */}
        <section className="about-hero">
          <div className="container">
            <h1>About Us</h1>

            <p>
              Our Story &nbsp;|&nbsp; Our Craft &nbsp;|&nbsp; Our Promise
            </p>

            <div className="breadcumb-menu-wrap mt-3">
              <ul className="breadcumb-menu">
                <li>
                  <a href="/">Home</a>
                </li>

                <li>/</li>

                <li>About Us</li>
              </ul>
            </div>
          </div>
        </section>

        {/* STORY */}
        <section className="story-section">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <div className="story-img-wrap">
                  <img
                    src="/assets/img/about/about-1-1.jpg"
                    alt="about"
                  />

                  <div className="story-badge">
                    <span className="badge-num">5+</span>

                    <span className="badge-text">
                      Years of Craft
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <span className="story-label">Who We Are</span>

                <h2 className="story-heading">
                  Crafting Timeless
                  <br />
                  Jewellery with Soul
                </h2>

                <p className="story-text">
                  Ninesister Jewels was born from a deep love for handcrafted
                  beauty and the rich tradition of Indian jewellery-making.
                  Founded by nine sisters who share a passion for artistry,
                  we set out to create pieces that are not just ornaments —
                  but heirlooms, memories, and expressions of identity.
                </p>

                <p className="story-text">
                  Every ring, necklace, earring, and bangle that leaves our
                  workshop carries with it the careful attention of skilled
                  artisans. We blend classic designs with contemporary
                  sensibilities, making our jewellery perfect for every woman,
                  every occasion, every moment.
                </p>

                <p className="story-text">
                  From our workshop to your wardrobe — we pour heart into
                  every piece.
                </p>

                <div className="d-flex gap-4 mt-4 flex-wrap">
                  <a href="/shop" className="vs-btn">
                    Shop Collection
                  </a>

                  <a href="/contact" className="contact-link">
                    Contact Us →
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* VALUES */}
        <section className="values-section">
          <div className="container">
            <div className="text-center mb-5">
              <span className="section-label">
                What We Stand For
              </span>

              <h2 className="section-title">
                Our Core Values
              </h2>

              <div className="title-line"></div>
            </div>

            <div className="row g-4">
              <div className="col-md-6 col-lg-3">
                <div className="value-card">
                  <span className="value-icon">💎</span>

                  <h3 className="value-title">Authenticity</h3>

                  <p className="value-desc">
                    Every piece is genuinely handcrafted. No mass
                    production. No shortcuts.
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3">
                <div className="value-card">
                  <span className="value-icon">🌸</span>

                  <h3 className="value-title">Elegance</h3>

                  <p className="value-desc">
                    Timeless, refined and graceful jewellery
                    crafted beautifully.
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3">
                <div className="value-card">
                  <span className="value-icon">🤝</span>

                  <h3 className="value-title">Trust</h3>

                  <p className="value-desc">
                    Transparent pricing, honest quality and
                    relationships built on trust.
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3">
                <div className="value-card">
                  <span className="value-icon">♻️</span>

                  <h3 className="value-title">Responsibility</h3>

                  <p className="value-desc">
                    Ethically sourced materials and sustainable
                    craftsmanship.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* STATS */}
        <section className="stats-section">
          <div className="container">
            <div className="row g-0 text-center">
              <div className="col-6 col-md-3">
                <div className="stat-item">
                  <div className="stat-num">5000+</div>

                  <div className="stat-label">
                    Happy Customers
                  </div>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="stat-item">
                  <div className="stat-num">200+</div>

                  <div className="stat-label">
                    Unique Designs
                  </div>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="stat-item">
                  <div className="stat-num">5+</div>

                  <div className="stat-label">
                    Years of Craft
                  </div>
                </div>
              </div>

              <div className="col-6 col-md-3">
                <div className="stat-item">
                  <div className="stat-num">9</div>

                  <div className="stat-label">
                    Founding Sisters
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* WHY US */}
        <section className="whyus-section">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-5">
                <span className="section-label">
                  Why Us
                </span>

                <h2 className="section-title">
                  Reasons to Choose
                  <br />
                  Ninesister Jewels
                </h2>

                <div className="title-line left"></div>

                <div className="whyus-item">
                  <span className="whyus-num">01</span>

                  <div className="whyus-content">
                    <h4>Handcrafted with Love</h4>

                    <p>
                      Each piece is lovingly made by skilled artisans.
                    </p>
                  </div>
                </div>

                <div className="whyus-item">
                  <span className="whyus-num">02</span>

                  <div className="whyus-content">
                    <h4>Premium Quality Materials</h4>

                    <p>
                      Certified metals and genuine gemstones only.
                    </p>
                  </div>
                </div>

                <div className="whyus-item">
                  <span className="whyus-num">03</span>

                  <div className="whyus-content">
                    <h4>Custom Orders</h4>

                    <p>
                      Custom jewellery crafted exactly how you imagine.
                    </p>
                  </div>
                </div>

                <div className="whyus-item">
                  <span className="whyus-num">04</span>

                  <div className="whyus-content">
                    <h4>Pan-India Delivery</h4>

                    <p>
                      Safe and secure delivery across India.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-7">
                <div className="row g-3">
                  <div className="col-6">
                    <img
                      src="/assets/img/about/about-1-3.jpg"
                      className="why-img"
                      alt=""
                    />
                  </div>

                  <div className="col-6">
                    <img
                      src="/assets/img/about/about-1-4.jpg"
                      className="why-img top-space"
                      alt=""
                    />
                  </div>

                  <div className="col-12">
                    <img
                      src="/assets/img/about/about-1-1.jpg"
                      className="why-img bottom-img"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CONTACT */}
        <section className="contact-strip">
          <div className="container">
            <div className="row g-4 justify-content-center text-center">
              <div className="col-md-4">
                <div className="contact-box">
                  <div className="contact-icon">📍</div>

                  <h5>Visit Us</h5>

                  <p>Ninesister Jewels India</p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="contact-box middle">
                  <div className="contact-icon">📞</div>

                  <h5>Call Us</h5>

                  <p>(+91) 89282 18258</p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="contact-box">
                  <div className="contact-icon">✉️</div>

                  <h5>Email Us</h5>

                  <p>Ninesisters0819@gmail.com</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="cta-section">
          <div className="container">
            <span className="section-label">
              Start Shopping
            </span>

            <h2>Discover Our Collections</h2>

            <p>
              Explore handcrafted rings, necklaces, earrings and
              bangles made with love.
            </p>

            <div>
              <a href="/shop" className="cta-btn">
                Shop Now
              </a>

              <a href="/contact" className="cta-btn outline">
                Contact Us
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </main>

      <ScrollToTop />
    </>
  );
};

export default About;